import { FileOutlinedOutlineIcon } from '@carboncopyco/icons';
import type { MouseEventHandler } from 'react';
import { SidebarButton } from './SidebarButton';

export interface PlaygroundButtonProps {
  isSelected: boolean;
  onClick: MouseEventHandler<HTMLButtonElement>;
}

export const PlaygroundButton = ({
  isSelected,
  onClick,
}: PlaygroundButtonProps) => (
  <SidebarButton
    isSelected={isSelected}
    onClick={onClick}
    tooltipText="Playground"
    aria-label="Playground"
  >
    <FileOutlinedOutlineIcon size={20} />
  </SidebarButton>
);
